import Vue from "vue";
import Vuex from "vuex";

import Moment from "../utils/moment.js"
Vue.use(Vuex);
import mutations from './mutations'
/** 全局参数 */
export default new Vuex.Store({
  state: {
    result_success:'SUCCESS',
    result_error:'ERROR',
    isActiveButton: "true", //控制tabbar显示隐藏
    mobilePhone: "",
    userName: "",
    city_object:{
      id:'',
      name:''
    },
    date_object :{
      checkIn: {
        date: '',
        month: '',
        day: '',
        week: '',
        dateshow:''
      },
      checkOut: {
        date: '',
        month: '',
        day: '',
        week: '',
        dateshow:''
      },
      day:''
    }
  },

  mutations,
  actions: {}

});



// WEBPACK FOOTER //
// ./src/store/store.js